import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

const Navdata = () => {
  const history = useHistory();
  //state data
  const [isDashboard, setIsDashboard] = useState(false);
  const [isUsers, setIsUsers] = useState(false);
  const [isServices, setIsServices] = useState(false);
  const [isAds, setIsAds] = useState(false);
  const [isComplains, setIsComplains] = useState(false);
  const [isNotifications, setIsNotifications] = useState(false);
  const [isPlaces, setIsPlaces] = useState(false);
  const [isOrders, setIsOrders] = useState(false);
  const [isPrivacyPolicy, setIsPrivacyPolicy] = useState(false);

  const [iscurrentState, setIscurrentState] = useState("Dashboard");

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
    if (iscurrentState !== "Dashboard") {
      setIsDashboard(false);
    }
    if (iscurrentState !== "Users") {
      setIsUsers(false);
    }
    if (iscurrentState !== "Services") {
      setIsServices(false);
    }
    if (iscurrentState !== "Ads") {
      setIsAds(false);
    }
    if (iscurrentState !== "Notifications") {
      setIsNotifications(false);
    }
    if (iscurrentState !== "Places") {
      setIsPlaces(false);
    }
    if (iscurrentState !== "Complains") {
      setIsComplains(false);
    }
    if (iscurrentState !== "Orders") {
      setIsOrders(false);
    }
    if (iscurrentState !== "PrivacyPolicy") {
      setIsPrivacyPolicy(false);
    }
  }, [
    history,
    iscurrentState,
    isDashboard,
    isUsers,
    isServices,
    isAds,
    // isPlans,
    isNotifications,
    isPlaces,
    isOrders,
  ]);

  const menuItems = [
    {
      label: "Common.Menu",
      isHeader: true,
    },
    {
      id: "dashboard",
      label: "Dashboard.Dashboard",
      icon: "ri-dashboard-2-line",
      link: "/#",
      stateVariables: isDashboard,
      click: function (e) {
        e.preventDefault();
        setIsDashboard(!isDashboard);
        setIscurrentState("Dashboard");
        updateIconSidebar(e);
      },
    },
    {
      id: "users",
      label: "Common.Users",
      icon: "ri-shield-user-line",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsUsers(!isUsers);
        setIscurrentState("Users");
        updateIconSidebar(e);
      },
      stateVariables: isUsers,
      subItems: [
        {
          id: "customers",
          label: "Customers.Customers",
          link: "/users/customers",
          parentId: "users",
        },
        {
          id: "technicians",
          label: "Technicians.Technicians",
          link: "/users/technicians",
          parentId: "users",
        },
        {
          id: "notification",
          label: "Notifications.Notify Users",
          link: "/users/notify",
          parentId: "users",
        },
      ],
    },
    {
      id: "services",
      label: "Services.Services",
      icon: "ri-customer-service-line",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsServices(!isServices);
        setIscurrentState("Services");
        updateIconSidebar(e);
      },
      stateVariables: isServices,
      subItems: [
        {
          id: "categories",
          label: "Categories.Categories",
          link: "/services/categories",
          parentId: "services",
        },
        {
          id: "services",
          label: "Services.Services",
          link: "/services/services",
          parentId: "services",
        },
      ],
    },
    {
      id: "ads",
      label: "Ads.Ads & Banners",
      icon: "ri-advertisement-line",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsAds(!isAds);
        setIscurrentState("Ads");
        updateIconSidebar(e);
      },
      stateVariables: isAds,
      subItems: [
        {
          id: "ads",
          label: "Ads.Ads",
          link: "/ads",
          parentId: "ads",
        },
      ],
    },
    {
      id: "complains",
      label: "Complains.Complains",
      icon: "ri-feedback-line",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsComplains(!isComplains);
        setIscurrentState("Complains");
        updateIconSidebar(e);
      },
      stateVariables: isComplains,
      subItems: [
        {
          id: "complains",
          label: "Complains.Complains",
          link: "/complains",
          parentId: "complains",
        },
      ],
    },
    {
      id: "places",
      label: "Common.Places",
      icon: "ri-map-pin-line",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsPlaces(!isPlaces);
        setIscurrentState("Places");
        updateIconSidebar(e);
      },
      stateVariables: isPlaces,
      subItems: [
        {
          id: "governorates",
          label: "Governorates.Governorates",
          link: "/places/governorates",
          parentId: "places",
        },
        {
          id: "cities",
          label: "Cities.Cities",
          link: "/places/cities",
          parentId: "places",
        },
      ],
    },
    {
      id: "orders",
      label: "Orders.Orders",
      icon: "ri-shopping-basket-fill",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsOrders(!isOrders);
        setIscurrentState("Orders");
        updateIconSidebar(e);
      },
      stateVariables: isOrders,
      subItems: [
        {
          id: "orders",
          label: "Orders.Orders",
          link: "/Orders",
          parentId: "orders",
        },
      ],
    },
    {
      id: "privacyPolicy",
      label: "PrivacyPolicy.Privacy Policy",
      icon: "ri-shield-user-fill",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsPrivacyPolicy(!isPrivacyPolicy);
        setIscurrentState("PrivacyPolicy");
        updateIconSidebar(e);
      },
      stateVariables: isPrivacyPolicy,
      subItems: [
        {
          id: "privacyPolicy",
          label: "PrivacyPolicy.Privacy Policy",
          link: "/privacy-policies",
          parentId: "privacyPolicy",
        },
      ],
    },
  ];
  return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;
